import * as types from './mutation-types';

export default {
  [types.SET_ACCOUNT_COLLECTION](state, payload) {
    state.accountCollection = payload;
  },
};
